import React, { PureComponent } from "react";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

import styles from './style.css';
import UQFormErrors from "../../../../uq-forms/components/form-errors";
import LayoutComponentsHeader from "../../../../layout/ui/components/header";
import Div100vh from "../../../../uq-ui/components/div-100";
import UQFormsTextField from "../../../../uq-forms/components/text-field";
import { saveInitialProfileInfo } from '../../../../account/store/actions';
import { currentUserSelector } from '../../../store/auth-user/selectors';
import UQButton from '../../../../uq-ui/components/button';
import UQFormsBirthdayRoundedField from '../../../../uq-forms/components/birthday-rounded-field';
import { isValidBirthday } from '../../../../uq-ui/helpers/dateValidator';

const GreetingImage = require('./greeting.svg');

class ProfileInfoScreens extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      display_name: '',
      birthday_date: '',
      birthdayError: null
    }
  }

  componentDidMount() {
    if (!this.props.currentUser) {
      this.props.history.replace('/');
    } else if (!this.props.currentUser.isNew) {
      this.props.history.replace('/');
    }
  }

  onBack = () => {
    this.props.history.goBack();
  }

  onBirthDateChange = (birthday_date) => {
    this.setState({ birthday_date });
  }

  onSave = () => {
    const { display_name, birthday_date } = this.state;
    if (isValidBirthday(birthday_date)) {
      this.setState({ birthdayError: null });
      this.props.save({display_name, birthday_date});
    } else {
      this.setState({ birthdayError: this.props.t('birthdayInvalid') });
    }
  }

  render() {
    const titleStyle = document.body.clientHeight < 550 ? { marginBottom: '1%', fontSize: 23 } : {};
    const descStyle = document.body.clientHeight < 550 ? { marginBottom: '1%' } : {};
    const birthdayContainerStyle = document.body.clientHeight < 550 ? { padding: '5px 30px' } : {};
    return (
      <Div100vh className={styles.container}>
        <LayoutComponentsHeader showBackBtn={true} 
                                onBack={this.onBack}
                                showLogo={true} />
        <div className={styles.innerTop}>
          <div style={titleStyle} className={`${styles.title} font-title`}>{this.props.t('title')}</div>
          <div style={descStyle} className={`${styles.desc} font-title`}>{this.props.t('desc')}</div>
          <div className={styles.formContainer}>
            <UQFormsTextField
                margin="none"
                label={this.props.t('nameLabel')}
                labelClassName={`${styles.nameLabel} font-text`}
                autoCapitalize="none"
                value={this.state.display_name}
                onChange={(event) => this.setState({ display_name: event.target.value })}
              />
          </div>
          <div className={styles.birthdayContainer} style={birthdayContainerStyle}>
            <div className={`${styles.birthdayLabel} font-text`}>{this.props.t('birthdayLabel')}</div>
            <UQFormsBirthdayRoundedField onChange={this.onBirthDateChange}/>
          </div>
          <UQFormErrors textClass={`${this.state.birthdayError? styles.activeErrorText : styles.errorText}`}
                        error={this.state.birthdayError}/>
          <UQButton label={this.props.t('startBtn')}
                    containerClass={styles.button}
                    onPress={this.onSave}/>
        </div>
        <div className={styles.innerBottom}>
          <img src={GreetingImage} className={styles.greeting} />
        </div>
      </Div100vh>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: currentUserSelector(state)
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    save: (info) => dispatch(saveInitialProfileInfo(info)),
  }
};

export default compose(
  withTranslation('scr-profile-info'),
  connect(mapStateToProps, mapDispatchToProps)
)(ProfileInfoScreens);